// extracted by mini-css-extract-plugin
module.exports = {"block":"SitemapPage_block_3r9oJ"};